import { SimpleSocketType } from "UidispatcherApiModule";
const { SimpleSocket }: { SimpleSocket: SimpleSocketType } =
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    await import("uidispatcher_api/UidispatcherApiModule");
export default SimpleSocket;
